// TermsPage.jsx
import React from "react";
import "./baseStyles.css";

export default function TermsPage() {
  return (
    <div className="legal-container">
      <h1>Terms of Service</h1>
      <p>Welcome to MyDailyReminders. By accessing or using our website and services, you agree to be bound by these terms.</p>

      <h2>Use of Service</h2>
      <p>Our services are designed to help users build better habits and relationships through reminders and games. You agree not to misuse our services or use them in any unlawful way.</p>

      <h2>SMS Consent</h2>
      <p>By providing your phone number, you consent to receive automated text messages from us. Message and data rates may apply. You may opt out at any time by replying STOP.</p>

      <h2>Termination</h2>
      <p>We reserve the right to suspend or terminate your access to our services at any time for violations of these terms.</p>

      <h2>Disclaimer</h2>
      <p>Our services are provided as-is without any warranties. We are not responsible for losses arising from your use of the service.</p>

      <p>For more information, contact support@mydailyreminders.com.</p>
    </div>
  );
}
